////////////////////////////////////////////////////////////////////////////////
//
// Kiosk API module
//
////////////////////////////////////////////////////////////////////////////////

import ApiService from "@/services/api.service";

////////////////////////////////////////////////////////////////////////////////

const kiosk = {
    /**
     * Get all accounts
     * @returns {Promise<AxiosResponse<any>>}
     */
    all: () => ApiService.getT('kiosk'),

    /**
     * Add a account with data
     * @param data
     * @returns {Promise<AxiosResponse<any>>}
     */
    add: (data) => ApiService.postT('kiosk', data),

    /**
     * Delete account with name
     * @param name
     * @returns {Promise<AxiosResponse<any>>}
     */
    del: (name) => ApiService.deleteT(`kiosk/${name}`),

    /**
     * Save Site with data
     * @param name dataview resource name
     * @param data { "description": "", "name": "", ... }
     */
    save: (name, data) => {
        const dataCopy = { ...data }
        if (name === dataCopy.name) {
            delete dataCopy.name
        }
        const putData = { operator: { $set: dataCopy } }
        return ApiService.putT(`kiosk/${name}`, putData)
    }
}

export default kiosk;